<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-Back">
      <rect width="24" height="24"/>
    </clipPath>
  </defs>
  <g id="Back" clip-path="url(#clip-Back)">
    <rect width="24" height="24" fill="rgba(81,91,96,0)"/>
    <g id="Group_13313" data-name="Group 13313">
      <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" fill="rgb(164, 58, 69)"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "doneIcon",
    props: ['height', 'width']
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/DoneIcon.vue